export default "/_next/static/images/donate-0699d9536bf1bf8f9af45806e1ff64f2.png";